import { useState, useEffect } from "react";
import PageBanner from "../components/PageBanner";
import Seo from "../components/Seo";
import { Reveal } from "../components/Motion";
import { useApp, api } from "../AppContext";
import { C, IMAGES } from "../content";
import { CalendarDays } from "lucide-react";

export default function Festivals() {
  const { t, lang } = useApp();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/festivals").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <Seo title="Festivals & Events" description="Krishna Mai Utsav, Shripad Shrivallabh Utsav, Narasimha Saraswati Jayanti, Datta Jayanti and Guru Purnima celebrations at Shri Datta Kshetra Audumbar." />
      <PageBanner label={lang === "mr" ? "उत्सव" : "Festivals"} titleObj={C.festivals || { title_mr: "उत्सव व कार्यक्रम", title_en: "Festivals & Events" }} image={IMAGES.courtyardTree} />
      <section className="py-16 lg:py-24 max-w-[1100px] mx-auto px-4 lg:px-8">
        <div className="space-y-5">
          {items.map((f, i) => (
            <Reveal key={f.id} delay={i * 0.05}>
              <div className="grid md:grid-cols-[180px_1fr] gap-5 rounded-2xl border border-earth-900/10 bg-white p-6 lg:p-8" data-testid={`festival-${i}`}>
                <div className="flex md:flex-col items-center md:items-start gap-3">
                  <div className="w-12 h-12 rounded-xl bg-deepred-700/10 text-deepred-700 flex items-center justify-center"><CalendarDays size={24} /></div>
                  <span className="text-saffron-600 font-semibold">{t(f, "month") || f.date}</span>
                </div>
                <div>
                  <h3 className="font-serif-head text-2xl lg:text-3xl text-earth-900">{t(f, "name")}</h3>
                  <p className="mt-2 text-earth-800/80 text-lg">{t(f, "desc")}</p>
                  {f.date && <p className="mt-2 text-sm text-earth-600">{f.date}</p>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-16">
          <div className="rounded-3xl bg-sand-100 border border-earth-900/10 p-8 text-center">
            <h3 className="font-serif-head text-2xl text-earth-900 mb-2">{lang === "mr" ? "मागील उत्सवांची झलक" : "Coverage from Past Festivals"}</h3>
            <p className="text-earth-700">{lang === "mr" ? "छायाचित्रे व व्हिडिओ लवकरच ट्रस्टच्या फेसबुक पेजवरून जोडले जातील." : "Photos and videos will be added soon from the Trust's Facebook page."}</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
